export const SlotTime = {
  NINE_AM: { title: "9 AM - 10 AM", value: "9 AM" },
  TEN_AM: { title: "10 AM - 11 AM", value: "10 AM" },
  ELEVEN_AM: { title: "11 AM - 12 PM", value: "11 AM" },
  TWELVE_PM: { title: "12 PM - 1 PM", value: "12 PM" },
  ONE_PM: { title: "1 PM - 2 PM", value: "1 PM" },
  TWO_PM: { title: "2 PM - 3 PM", value: "2 PM" },
  THREE_PM: { title: "3 PM - 4 PM", value: "3 PM" },
  FOUR_PM: { title: "4 PM - 5 PM", value: "4 PM" },
  FIVE_PM: { title: "5 PM - 6 PM", value: "5 PM" },
  SIX_PM: { title: "6 PM - 7 PM", value: "6 PM" },
};

export const Gender = {
  MALE: "Male",
  FEMALE: "Female",
  OTHER: "Other",
};

export const JustDialURL = "https://www.justdial.com/Ramgarh-Jharkhand/Prasad-Eye-Hospital-Ramgarh-Cantt/9999P6553-6553-170402180007-H9G3_BZDET?via=scode";
